module.exports = __webpack_public_path__ + "img/marisa kirisame witch of scarlet dreams_sc2.a8a10a4d.png";